import React from 'react'
import '../Style/InfoPage.css'
import '../Style/projects.css'
import { useState, useEffect, useRef } from "react";
import close from "../Graphics/x.png"
import websiteCard from "../Graphics/websitecard.png"
import ggLogo from "../Graphics/GG-logo.png"
import placeholder from "../Graphics/placeholdercard.png"
import steamFriends from "../Graphics/steamfriendsforever.png"
import discord from "../Graphics/discord.png"


import Card from '../Card';

const InfoPage = ({setVis, visible}) => {
  

    const [borderWidth,setBorderWidth] = useState(0);
     const [borderHeight,setBorderHeight] = useState(0);
     const insideRef = useRef(null);
 
    const offset=16;
   function pixelSpacing(){
   if(!insideRef.current) return;
   const insideDiv=insideRef.current.getBoundingClientRect();
   
   setBorderHeight(insideDiv.height+offset);
   setBorderWidth(insideDiv.width+offset);
  
 }

   useEffect(() => {
     // Call the function initially to set the values
     pixelSpacing();
 
     // Add event listener for window resize
     window.addEventListener('resize', pixelSpacing);
 
     // Cleanup the event listener on component unmount
     return () => {
       window.removeEventListener('resize', pixelSpacing);
     };
   }, [visible]);

  return (
    <div className={visible ? "main" : "main panelHidden"}>
      <div className="verticalOutline" style={{height:`${borderHeight}px`,top:`${-(offset/2)}px`}}></div>
      <div className="horizontalOutline" style={{width:`${borderWidth}px`,left:`${-(offset/2)}px`}}></div>
      <img src={close} alt="Close" className="closeButton" onClick={() => setVis(-1)}/>
      <div className="inside" ref={insideRef} style={{borderWidth:`${(offset/2)}px`,textAlign:"center"}}>
      <h2>Projects</h2>
      <p>Hover over or tap cards to learn more about each</p>
       <div className='cards'>


          <Card background={discord}>
            <h3 style={{textAlign:'center'}}>Discord Modding RAG</h3>
              <p>Stores 10+ million otherwise unsearchable discord messages in a vector database, letting agents
              query it through approximate nearest neighbor to add context to their replies. A self hosted LLM
              untangles the messages into conversations and classifies them before they are embedded</p>
              <p>Used:</p>
              <ul>
                <li>Python</li>
                <li>PyTorch</li>
                <li>ChromaDB</li>
                <li>BertTopic</li>
                <li>Embedders</li>
              </ul>
          </Card>

          <Card background={steamFriends}>
            <h3 style={{textAlign:'center'}}>Steam Friends Forever</h3>
              <p>Builds an adjacency matrix for any Steam user, grouping their friends by the game genres they
              share the most hours in. Handles the Steam Web API's 200 packets/minute rate limit with retry
              logic and throttling, and is deployed on a VPS behind NGinx and Cloudflare</p>
              <p>Used:</p>
              <ul>
                <li>React</li>
                <li>C++</li>
                <li>Node.js/Express</li>
                <li>CloudFlare</li>
                <li>Linux</li>
              </ul>
          </Card>

          <Card background={websiteCard}>
            <h3 style={{textAlign:'center'}}>This Website!</h3>
              <p>Used:</p>
              <ul>
                <li>React</li>
                <li>CSS</li>
                <li>HTML</li>
                <li>JavaScript</li>
              </ul>
          </Card>

          <Card background={ggLogo} fit="contain">
        <h3 style={{textAlign:'center'}}>Overstuffed</h3>
                <p>Used:</p>
                <ul>
                  <li>Java</li>
                  <li>Gradle/Koitlin</li>
                  <li>JSON</li>
                </ul>
                <p>Learned:</p>
                <ul>
                  <li>Networking</li>
                  <li>User Interface Design</li>
                  <li>Utilizing API's</li>
                  <li></li>
                </ul>

          </Card>
       </div>
      </div>
    </div>
  )
}

export default InfoPage